<template>
  <span>
    <b-dropdown id="dropdown-right" :disabled="open || open2" right>
      <template slot="button-content">
        <span class="banderas">
          <img
            class="img-rounded bandera"
            :class="[esoculto ? '' : 'oculto']"
            src="../../assets/img/espanol.svg"
            v-bind:alt="$t('language.posadasCorporate.posadasCorporate')"
          />
          <img
            class="img-rounded bandera"
            :class="[esoculto ? 'oculto' : '']"
            src="../../assets/img/usa.svg"
            v-bind:alt="$t('language.posadasCorporate.posadasCorporate')"
          />
        </span>
      </template>
      <b-dropdown-item href="#" @click="setLocale('es'), [esoculto = true]" class="idiomas">
        <section class="flags">
          <span class="d-inline-block ">
            <img
              class
              src="../../assets/img/espanol.svg"
              v-bind:alt="$t('language.posadasCorporate.recuperarPassword.fotoBanderaEspanol')"
            />
          </span>
          <div class="d-inline-block ml-2">
            <b class="f-w-500">{{ $t('language.posadasCorporate.recuperarPassword.espanol') }}</b>
          </div>
        </section>
      </b-dropdown-item>
      <b-dropdown-item href="#" @click="setLocale('en'), [esoculto = false]" class="idiomas">
        <section class="flags">
          <span class="d-inline-block ">
            <img
              class="img-rounded"
              src="../../assets/img/usa.svg"
              v-bind:alt="$t('language.posadasCorporate.recuperarPassword.fotoBanderaIngles')"
            />
          </span>
          <div class="d-inline-block ml-2">
            <b class="f-w-500">{{ $t('language.posadasCorporate.recuperarPassword.ingles') }}</b>
          </div>
        </section>
      </b-dropdown-item>
    </b-dropdown>
  
  </span>
</template>

<script>
import SecureLS from "secure-ls";
const STORAGE_KEY = {
  Token: "Token",
  GroupId: "GroupId",
  ClientId: "ClientId",
  User: "User",
  Password: "Password",
  Language: "Language"
};

export default {
  name: "Languages",
  data: () => {
    return {
      open: false,
      open2: false,
      hidden: "hiddenn",
      visibility: "",
      esoculto: true
    };
  },
  watch: {
      disableLanguages() {
         if(this.disableLanguages) {
           this.open = true 
         } else {
           this.open = false 

         }
       }
  },
  computed: {
      disableLanguages() {
     if(this.$store.getters.gettingLangBlock) {
this.open = true 
       return true
     } else {
       this.open = false 
       return false

     }
      }
  },
  methods: {
    switchHidden() {
      this.hidden = this.hidden === "hiddenn" ? "" : "hiddenn";
    },
    setLocale(locale) {
    if (locale == undefined) {
      locale = 'es'
    }
    this.$i18n.locale = locale;
    this.switchHidden();
    var ls = new SecureLS({ encodingType: "aes" });
    ls.set("Language", { data: locale });
     var a = ls.get("Language");
     if (a.data == 'es') {
      this.$store.commit('changeLanguageSpanish');
     } else {
      this.$store.commit('changeLanguageEnglish');
     }
    }
    
  },
  created() {
     var currentLocation = window.location; 
      if( currentLocation.pathname == "/administracion-de-usuarios" || currentLocation.pathname == "/reservaciones-registro" || currentLocation.pathname == "/busqueda-avanzada" || currentLocation.pathname == "/busqueda-seguimiento" || currentLocation.pathname == "/movimientos-del-dia" || currentLocation.pathname == "/reservaciones-cancelacion" || currentLocation.pathname == "/reservaciones-modificar" || currentLocation.pathname =="/reservaciones-modificar-lectura") {
      this.open2 = true
      }
      if(currentLocation.pathname == "/informacion-corporate" || currentLocation.pathname == "/informacion-adicional") {
      this.open2 = false

      }
    var ls = new SecureLS({ encodingType: "aes" });
    var languageStorage = ls.get("Language");
    if (languageStorage == undefined) {
      ls.set('Language', {data: 'es'});
           this.$store.commit('changeLanguageSpanish');

    }
    this.setLocale(languageStorage.data);
    if (languageStorage.data == 'es') {
           this.$store.commit('changeLanguageSpanish');

      this.esoculto = true;
    }
    if (languageStorage.data == 'en') {
      this.esoculto = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.hiddenn {
  display: none;
}

.bandera {
  width: 24px;
  height: 24px;
}

.flags {
  width: 24px;
  height: 24px;
  figure {
    padding-right: 10px;
  }
  b {
    margin: 0;
  }
  img {
    width: 100%;
  }
}

.oculto {
  display: none;
  visibility: hidden;
}

</style>
